import { addNewHolidayQuoteX, patchHolidayQuoteX } from "@/store/modules/holiday-quotes-x/holiday-quotes.slice";
import { SocketConnector } from "@sdk/@libs/socket-connector";

import { Store } from "redux";
import { Socket } from "socket.io-client";
import {
  addNewActivity,
  patchActivity,
} from "store/modules/activities/activities.slice";
import {
  addNewBooking,
  patchBooking,
} from "store/modules/bookings/bookings.slice";
import {
  addNewBookingDiscussionItem,
  patchBookingDiscussionItem,
} from "store/modules/booking-discussion-items/booking-discussion-items.slice";
import {
  addNewBookingActivityLog,
  patchBookingActivityLog,
} from "store/modules/booking-activity-logs/booking-activity-logs.slice";
import {
  addNewCustomerInvoice,
  patchCustomerInvoice,
} from "store/modules/customer-invoices/customer-invoices.slice";
import {
  addNewCustomerPaymentReceipt,
  patchCustomerPaymentReceipt,
} from "store/modules/customer-payment-receipts/customer-payment-receipts.slice";
import {
  addNewSupplierBill,
  patchSupplierBill,
} from "store/modules/supplier-bills/supplier-bills.slice";
import {
  addNewSupplierBillPaymentReceipt,
  patchSupplierBillPaymentReceipt,
} from "store/modules/supplier-bill-payment-receipts/supplier-bill-payment-receipts.slice";
import { setSocketStatus } from "store/modules/app-state/app-state.actions";
import {
  addNewContactList,
  patchContactList,
} from "store/modules/contact-lists/contact-lists.slice";
import { loadContactById } from "store/modules/contacts/contacts.helpers";

import {
  addNewContact,
  patchContact,
  removeContactRecord,
} from "store/modules/contacts/contacts.slice";

import { addNewGroup, patchGroup } from "store/modules/groups/groups.slice";
import {
  addNewHolidayQuote,
  patchHolidayQuote,
} from "store/modules/holiday-quotes/holiday-quotes.slice";

import {
  addNewNotification,
  patchNotification,
} from "store/modules/notifications/notifications.slice";

import {
  addNewOpportunity,
  patchOpportunity,
} from "store/modules/opportunities/opportunities.slice";

import {
  addNewScheduledReport,
  patchScheduledReport,
} from "store/modules/scheduled-reports/scheduled-reports.slice";
import { addNewTask, patchTask } from "store/modules/tasks/tasks.slice";
import {
  addNewBrand,
  patchBrand,
} from "store/modules/brands/brands.slice";
import {
  addNewCustomerPaymentMethod,
  patchCustomerPaymentMethod,
} from "store/modules/customer-payment-methods/customer-payment-methods.slice";
import {
  addNewSupplierPaymentMethod,
  patchSupplierPaymentMethod,
} from "store/modules/supplier-payment-methods/supplier-payment-methods.slice";
import {
  addNewSupplier,
  patchSupplier,
} from "store/modules/suppliers/suppliers.slice";
import { addNewUser, patchUser } from "store/modules/users/users.actions";
import {
  patchOrganization,
} from "store/modules/workspace/workspace.actions";

import { GlobalEventEmitter } from "utils/global-event-emitter";

let lastDisconnectedTime = 0;
export interface iSyncEvent {
  data: any;
  entityId: string;
  entityType: string;
  id: string;
  type: "UPDATE" | "NEW";
}

export interface iSpecialEvent {
  data: any;
  entity: string;
  id: string;
  name: string;
  organizationId: string;
}

export const HandleSocketEvents = (socket: Socket<any, any>, store: Store) => {
  socket.on("connect", () => {
    console.log("HSE: Connected");
    // Todo: Dispatch Action
    store.dispatch(setSocketStatus(true));
  });

  socket.on("reconnect", () => {
    console.log("HSE: Reconnected");
    // Todo: Dispatch Action
    // Check the last connected time gap and if the gap is bigger than 7 seconds, then reload
    store.dispatch(setSocketStatus(true));
    if (
      lastDisconnectedTime + 15 * 1000 < Date.now() &&
      !window.location.href.includes("localhost")
    ) {
      window.location.reload();
    }
  });

  socket.on("disconnect", () => {
    console.log("HSE: Disconnected");
    lastDisconnectedTime = Date.now();
    setTimeout(() => {
      if (!SocketConnector.socket?.connected) {
        // Todo: Dispatch Action
        store.dispatch(setSocketStatus(false));
      }
    }, 4000);
  });

  socket.on("SYNC", (data: iSyncEvent) => {
    // console.log("SYNC", data);
    if (data.type === "UPDATE") {
      switch (data.entityType) {
        case "ORGANIZATION": {
          store.dispatch(
            patchOrganization({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "USER": {
          store.dispatch(patchUser({ ...data.data, id: data.entityId }));
          break;
        }
        case "USER_GROUP": {
          store.dispatch(patchGroup({ ...data.data, id: data.entityId }));
          break;
        }

        case "CONTACT": {
          store.dispatch(patchContact({ ...data.data, id: data.entityId }));
          break;
        }

        case "OPPORTUNITY": {
          store.dispatch(patchOpportunity({ ...data.data, id: data.entityId }));
          break;
        }
        case "ACTIVITY": {
          store.dispatch(patchActivity({ ...data.data, id: data.entityId }));
          break;
        }
        case "CONTACT_LISTS": {
          store.dispatch(patchContactList({ ...data.data, id: data.entityId }));
          break;
        }
        // Scheduled Record
        case "SCHEDULED_REPORT": {
          store.dispatch(
            patchScheduledReport({ ...data.data, id: data.entityId })
          );
          break;
        }

        case "NOTIFICATION": {
          // Todo
          store.dispatch(
            patchNotification({ ...data.data, id: data.entityId })
          );
          break;
        }

        // Tasks
        case "TASK": {
          store.dispatch(patchTask({ ...data.data, id: data.entityId }));
          break;
        }

        // Holiday Quotes
        case "HOLIDAY_QUOTE": {
          store.dispatch(
            patchHolidayQuote({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "HOLIDAY_QUOTE_X": {
          store.dispatch(
            patchHolidayQuoteX({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "BOOKING": {
          store.dispatch(patchBooking({ ...data.data, id: data.entityId }));
          break;
        }
        case "BOOKING_DISCUSSION_ITEM": {
          store.dispatch(
            patchBookingDiscussionItem({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "BOOKING_ACTIVITY_LOG": {
          store.dispatch(
            patchBookingActivityLog({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "CUSTOMER_INVOICE": {
          store.dispatch(
            patchCustomerInvoice({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "CUSTOMER_PAYMENT_RECEIPT": {
          store.dispatch(
            patchCustomerPaymentReceipt({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "SUPPLIER_BILL": {
          store.dispatch(patchSupplierBill({ ...data.data, id: data.entityId }));
          break;
        }
        case "SUPPLIER_BILL_PAYMENT_RECEIPT": {
          store.dispatch(
            patchSupplierBillPaymentReceipt({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "SUPPLIER": {
          store.dispatch(
            patchSupplier({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "BRAND": {
          store.dispatch(patchBrand({ ...data.data, id: data.entityId }));
          break;
        }
        case "CUSTOMER_PAYMENT_METHOD": {
          store.dispatch(
            patchCustomerPaymentMethod({ ...data.data, id: data.entityId })
          );
          break;
        }
        case "SUPPLIER_PAYMENT_METHOD": {
          store.dispatch(
            patchSupplierPaymentMethod({ ...data.data, id: data.entityId })
          );
          break;
        }
        default: {
          console.log("Unidentified entity", data.entityType);
        }
      }
    } else if (data.type === "NEW") {
      switch (data.entityType) {
        case "USER": {
          store.dispatch(addNewUser(data.data));
          break;
        }
        case "USER_GROUP": {
          store.dispatch(addNewGroup(data.data));
          break;
        }
        case "CONTACT": {
          store.dispatch(addNewContact(data.data));
          break;
        }

        case "ACTIVITY": {
          store.dispatch(addNewActivity(data.data));
          break;
        }

        case "OPPORTUNITY": {
          store.dispatch(addNewOpportunity(data.data));
          break;
        }
        case "CONTACT_LISTS": {
          store.dispatch(addNewContactList(data.data));
          break;
        }

        case "NOTIFICATION": {
          store.dispatch(addNewNotification(data.data));
          break;
        }

        // Scheduled Report
        case "SCHEDULED_REPORT": {
          store.dispatch(addNewScheduledReport(data.data));
          break;
        }

        // Task
        case "TASK": {
          store.dispatch(addNewTask(data.data));
          break;
        }

        // Holiday Quotes
        case "HOLIDAY_QUOTE": {
          store.dispatch(addNewHolidayQuote(data.data));
          break;
        }
        // Holiday Quotes
        case "HOLIDAY_QUOTE_X": {
          store.dispatch(addNewHolidayQuoteX(data.data));
          break;
        }
        case "BOOKING": {
          store.dispatch(addNewBooking(data.data));
          break;
        }
        case "BOOKING_DISCUSSION_ITEM": {
          store.dispatch(addNewBookingDiscussionItem(data.data));
          break;
        }
        case "BOOKING_ACTIVITY_LOG": {
          store.dispatch(addNewBookingActivityLog(data.data));
          break;
        }
        case "CUSTOMER_INVOICE": {
          store.dispatch(addNewCustomerInvoice(data.data));
          break;
        }
        case "CUSTOMER_PAYMENT_RECEIPT": {
          store.dispatch(addNewCustomerPaymentReceipt(data.data));
          break;
        }
        case "SUPPLIER_BILL": {
          store.dispatch(addNewSupplierBill(data.data));
          break;
        }
        case "SUPPLIER_BILL_PAYMENT_RECEIPT": {
          store.dispatch(addNewSupplierBillPaymentReceipt(data.data));
          break;
        }
        case "SUPPLIER": {
          store.dispatch(addNewSupplier(data.data));
          break;
        }
        case "BRAND": {
          store.dispatch(addNewBrand(data.data));
          break;
        }
        case "CUSTOMER_PAYMENT_METHOD": {
          store.dispatch(addNewCustomerPaymentMethod(data.data));
          break;
        }
        case "SUPPLIER_PAYMENT_METHOD": {
          store.dispatch(addNewSupplierPaymentMethod(data.data));
          break;
        }

        default: {
          console.log("Unidentified entity", data.entityType);
        }
      }
    }
  });

  socket.on("SPECIAL_EVENTS", (data: iSpecialEvent) => {
    // console.log("SPECIAL_EVENTS", data);
    if (data.entity === "CONTACT") {
      switch (data.name) {
        case "CONTACT_MERGED": {
          console.log("CONTACT_MERGED");
          const { oldContactId, newContactId } = data.data as {
            oldContactId: string;
            newContactId: string;
          };
          // remove merged contact from store
          store.dispatch(removeContactRecord(oldContactId));
          // refresh merged contact
          loadContactById(newContactId)()(store, true);
          // refresh after a second too
          setTimeout(() => {
            loadContactById(newContactId)()(store, true);
          }, 2000);

          break;
        }
        default: {
          // Nothing
        }
      }
    }
  });

  socket.on("*", (eventName: string, data: any) => {
    const event = {
      name: eventName,
      payload: data,
    };
    if (event.name === "ABC") {
      // Todo:
    }
  });
};
